import CirclePlus from './src/circle-plus-combined';
export default CirclePlus;